import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  links: [], // Cambiado a un array vacío
  status: "idle",
  error: null,
};

export const linkSlice = createSlice({
  name: "links",
  initialState,
  reducers: {
    linkRequested: (state) => {
      state.status = "loading";
    },
    linkRequestFailed: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
    linkRequestSucceeded: (state, action) => {
      state.status = "succeeded";
      state.links = action.payload;
    },
  },
});

export const { linkRequested, linkRequestFailed, linkRequestSucceeded } =
  linkSlice.actions;

export default linkSlice.reducer;
